// @flow

import { useContext } from 'react';

import { type UserInputValues, type SetUserInputValue } from './types';
import { UserInputValuesContext } from './context';

export function useUserInputValues(): [UserInputValues, SetUserInputValue] {
  const tuple = useContext(UserInputValuesContext);
  if (!tuple) {
    throw new Error('UserInputValues was not provided');
  }
  return tuple;
}
